import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MasterApp } from './MasterApp';
import '../styles/base.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <MasterApp />
  </StrictMode>,
);
